import React from 'react';
import { connect } from 'react-redux';
import { Form, Input, message, Modal } from 'antd';
import * as actions from '../redux/actions/products';

class EditProduct extends React.Component {

    state = {
        confirmLoading: false,
    }
    layout = {
        labelCol: {
            span: 8,
        },
        wrapperCol: {
            span: 12,
        },
    };
    tailLayout = {
        wrapperCol: {
            offset: 12,
            span: 16,
        },
    };

    onFinish = async (values) => {
        let product = {
            id: this.props.editProduct.id,
            name: values.name,
        }
        await this.props.onUpdate(product, this.props.token);
        this.setState(prevState => {
            return {
                ...prevState,
                confirmLoading: true,
            }
        });
        setTimeout(() => {
            this.setState(prevState => {
                return {
                    ...prevState,
                    confirmLoading: false,
                }
            });
            if (this.props.editMessage) {
                message.success(this.props.editMessage);
            }
            if (this.props.editError) {
                message.error(this.props.editError);
            }
            this.props.onClear();
            this.props.onCloseForm();
        }, 400)
    }
    onFinishFailed = (errorInfo) => {
        message.error('All inputs are required. Input correctly.');
    }
    handleCancel = () => {
        this.props.onCloseForm();
    }
    render() {
        return (
            <Modal
                title="Edit Product"
                key={this.props.editProduct.id}
                centered
                visible={this.props.visible}
                okButtonProps={{ form: 'edit-product-form', key: 'submit', htmlType: 'submit' }}
                confirmLoading={this.state.confirmLoading}
                onCancel={this.handleCancel}
                okText="Save"
            >
                <Form
                    style={{ margin: 25 }}
                    id="edit-product-form"
                    {...this.layout}
                    name="basic"
                    initialValues={{
                        name: this.props.editProduct.name,
                    }}
                    onFinish={this.onFinish}
                    onFinishFailed={this.onFinishFailed}
                >
                    <Form.Item
                        name="name"
                        label="Name"
                        rules={[
                            {
                                required: true,
                                message: 'Require name!',
                            },
                            { min: 4, message: 'Minimum 4 characters.' },
                        ]}
                        hasFeedback
                    >
                        <Input />
                    </Form.Item>
                </Form>
            </Modal>
        );
    }
}
const mapStateToProps = state => {
    return {
        token: state.auth.token,
        editMessage: state.products.message,
        editError: state.products.error,
        visible: state.products.visibleEditForm,
        editProduct: state.products.editProduct,
    }
}
const mapDispatchToProps = dispatch => {
    return {
        onCloseForm: () => dispatch(actions.closeProductEditForm()),
        onUpdate: (product, token) => dispatch(actions.updateProduct(product, token)),
        onClear: () => dispatch(actions.clearProductEdit())
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(EditProduct);